<section>

  <gen-tabs-header *ngIf="tabs.length > 0" [tabs]="tabs" [currentTab]="currentTabTitle | translate"
                   (tabChange)="onTabChange($event)"
                   [ngClass]="stylemodifier"
                   [isCloseable]="tabClosable"
                   (tabClose)="onTabClose($event)">
  </gen-tabs-header>

  <div class="buttonUl">
    <span *ngFor="let button of buttons">
      <gen-button [type]="'emphasis'"
                  [ngClass]="buttonStyle"
                  (click)="emitAddTab(button.tabType)"
                  [text]="button.buttonTitle"
                  [iconClass]="'icon__plus'"></gen-button>
    </span>
  </div>
  <gen-dynamic-form *ngFor="let item of configData; index as i" class="info-dynamic-form"
                    [formName]="item.config.formId"
                    [formData]="item.data"
                    [listenToDataChange]="true"
                    [formVertical]="item.config.formVertical"
                    [editMode]="item.config.editMode"
                    [title]="item.config.title"
                    [itemCount]="item.config.showCount"
                    (formChange)="updateChanged($event,i)"

  >
  </gen-dynamic-form>

</section>
